// The filters an Insights detail page inherits from the dashboard, shown once as one read-only line under the page's
// heading (N5 pt 1): 'Showing All · Last 30 days · All cohorts (from Insights)'. The pages have no filter control of
// their own. The compliance page has no period, so it leaves the period out ('Showing All · All cohorts ...').
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { tokens } from '../../theme';
import { insightsService } from '../../services/api';

const T = tokens;
// The dashboard's own names for its choices, so the line reads as the controls it comes from.
const AUDIENCE_LABELS = { all: 'All users', external: 'External', internal: 'Internal' };
// The pages count anything else as the last 7 days (dateRange falls back to 7), so the line says what they show.
const PERIOD_LABELS = { '7d': 'Last 7 days', '30d': 'Last 30 days', '90d': 'Last 90 days' };

const InsightsFilterLine = ({ audience, period, cohort, withPeriod = true }) => {
  const oneCohort = !!cohort && cohort !== 'all';
  // The chosen cohort's name: undefined while it loads, null when it can't be found (the line then leaves it out).
  const [cohortName, setCohortName] = useState(undefined);

  // The cohort's name, from the list the dashboard's cohort control reads.
  useEffect(() => {
    if (!oneCohort) return undefined;
    let cancelled = false;
    setCohortName(undefined);
    insightsService.getCohorts()
      .then((r) => {
        const list = r && r.data && r.data.success ? r.data.data || [] : [];
        const found = list.find((c) => String(c.id) === String(cohort));
        if (!cancelled) setCohortName(found ? found.name : null);
      })
      .catch(() => { if (!cancelled) setCohortName(null); });
    return () => { cancelled = true; };
  }, [cohort, oneCohort]);

  if (oneCohort && cohortName === undefined) return null; // shown once the cohort's name is known
  const parts = [AUDIENCE_LABELS[audience] || AUDIENCE_LABELS.all];
  if (withPeriod) parts.push(PERIOD_LABELS[period] || 'Last 7 days');
  if (!oneCohort) parts.push('All cohorts');
  else if (cohortName) parts.push(cohortName);
  return (
    <Typography data-testid="insights-filter-line" sx={{ fontSize: T.font.size.sm, color: T.color.textSecondary, fontFamily: T.font.family, marginTop: '4px' }}>
      Showing {parts.join(' · ')} (from Insights)
    </Typography>
  );
};

export default InsightsFilterLine;
